import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getItemWithUserData } from '../../../api/items';

import { generateItemCIDKey } from '../../../components/Items/utils/generateItemCIDKey';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { mergeItemWithUserData } from '../../../utils/items';

export const fetchItem = createAsyncThunk(
  'items/fetchItem',
  async (itemData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [itemResponse, itemUserDataResponse] = await getItemWithUserData(
        itemData,
        {
          cancelToken: source.token,
        },
      );
      return mergeItemWithUserData(itemResponse, itemUserDataResponse);
    } catch (error) {
      return rejectWithValue(error?.response?.status);
    }
  },
);

export const fetchItemExtraReducers = builder => {
  builder
    .addCase(fetchItem.pending, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg.path);

      checkAndSetLoadingWithId(state.items.item.request, action, itemCIDKey);
    })
    .addCase(fetchItem.fulfilled, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg.path);

      onMatchedRequest(state.items.item.request[itemCIDKey], action, () => {
        state.items.item.byId[itemCIDKey] = action.payload;

        if (!state.items.item.allIds.includes(itemCIDKey)) {
          state.items.item.allIds.push(itemCIDKey);
        }
      });
    })
    .addCase(fetchItem.rejected, (state, action) => {
      handleRequestRejection(
        state.items.item.request[generateItemCIDKey(action.meta.arg.path)],
        action,
      );
    });
};
